import React from "react";
import { Box, Typography } from "@mui/material";
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";
import logoImage from "../../assets/images/logo.png";

function TerminosCondiciones() {
  const pageTitle = "Términos y Condiciones - Clinifica";
  const pageDescription = "Términos y Condiciones de Uso de Clinifica Chile SpA. Regulación del acceso y uso de la plataforma para profesionales de la salud.";

  const renderClinicaPillButton = () => {
    const handlePillClick = () => {
      window.location.href = "https://www.clinifica.com/pro";
    };

    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 4,
          mb: 4,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Quicksand-Regular",
            mb: 1.5,
            color: "#626262",
            fontSize: { md: "16px", xs: "14px" },
          }}
        >
          ¿Eres profesional de salud independiente?
        </Typography>

        <Box
          onClick={handlePillClick}
          sx={{
            display: "flex",
            alignItems: "center",
            bgcolor: "white",
            borderRadius: "50px",
            px: 3,
            py: 1,
            mb: 4,
            border: "1px solid #e0e0e0",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
              cursor: "pointer",
            },
            transition: "box-shadow 0.3s ease",
          }}
        >
          <Box
            sx={{
              mr: 1.5,
              color: "#4285F4",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 0,
            }}
          >
            <img
              src="/clinifica_logo.svg"
              alt="logo"
              style={{
                width: isMobile ? "27px" : "27px",
              }}
            />
          </Box>

          <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { md: "16px", xs: "14px" }, mb: 0 }}>
            Crea tu perfil gratis en{" "}
            <Box
              component="span"
              sx={{ fontFamily: "Quicksand-Bold", color: "#4285F4" }}
            >
              Clinifica
            </Box>
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
      </Helmet>

      <img
        src={logoImage}
        alt="Clinifica Logo"
        style={{
          width: isMobile ? "150px" : "200px",
          height: "auto",
          paddingTop: "15px",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          padding: 15,
        }}
      />

      <Box
        sx={{
          maxWidth: isMobile ? "94%" : "800px",
          width: isMobile ? "94%" : "90%",
          mx: "auto",
          bgcolor: "#fbfafe",
          boxShadow: 1,
          marginTop: 0,
          marginBottom: 8,
          borderRadius: 2,
          p: isMobile ? 2 : 4,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Quicksand-Bold",
            mb: 2,
            textAlign: "center",
            fontSize: { md: "28px", xs: "22px" },
          }}
        >
          TÉRMINOS Y CONDICIONES DE USO
        </Typography>

        <Typography
          sx={{
            fontFamily: "Quicksand-Regular",
            mb: 1,
            textAlign: "center",
            fontSize: { md: "16px", xs: "14px" },
            color: "#626262",
          }}
        >
          CLINIFICA CHILE SPA
        </Typography>

        <Typography
          sx={{
            fontFamily: "Quicksand-Regular",
            mb: 3,
            textAlign: "center",
            fontSize: { md: "14px", xs: "12px" },
            color: "#626262",
          }}
        >
          Última actualización: 29 de septiembre de 2025
        </Typography>

        <Box
          sx={{
            fontFamily: "Quicksand-Regular",
            fontSize: { xs: "14px", md: "16px" },
            color: "#09090a",
            lineHeight: "1.6",
            textAlign: "left",
            "& h2": {
              fontFamily: "Quicksand-Bold",
              fontSize: { md: "20px", xs: "18px" },
              mt: 3,
              mb: 2,
            },
            "& h3": {
              fontFamily: "Quicksand-SemiBold",
              fontSize: { md: "18px", xs: "16px" },
              mt: 2,
              mb: 1.5,
            },
            "& p": {
              mb: 2,
            },
            "& ul, & ol": {
              pl: 3,
              mb: 2,
            },
            "& li": {
              mb: 0.5,
            },
            "& a": {
              color: "#1976D2",
              textDecoration: "underline",
              "&:hover": {
                color: "#115293",
              },
            },
            "& strong": {
              fontFamily: "Quicksand-Bold",
            },
          }}
        >
          <h2>1. IDENTIFICACIÓN DEL PROVEEDOR DEL SERVICIO</h2>
          <p>
            Este documento establece los términos generales y condiciones de uso (los "Términos y Condiciones" o los "Términos") que regulan el acceso y uso que el "Usuario" o "Profesional de la Salud" realiza de la plataforma de software como servicio ("SaaS"), sus funcionalidades y demás servicios provistos por <strong>Clinifica Chile SpA</strong>, Rol Único Tributario N° 77.729.376-1, domiciliada en Eulogio Sánchez N° 065, comuna de Providencia, Región Metropolitana, Chile (en adelante, "Clinifica", la "Empresa", "nosotros" o "nuestro").
          </p>
          <p>
            Este documento contiene información legal relevante, por lo que se recomienda su lectura completa, junto con nuestra Política de Privacidad. La utilización de los servicios ofrecidos por Clinifica implica la aceptación expresa de estos Términos y Condiciones.
          </p>
          <p>
            A su vez tiene por objeto regular el uso de la Plataforma Clinifica y sus funcionalidades, las cuales pueden ser modificadas, ampliadas o limitadas por la Empresa, según su criterio técnico y comercial, lo que será debidamente informado a los Usuarios.
          </p>

          <h2>2. ACEPTACIÓN DE LOS TÉRMINOS Y CONDICIONES</h2>
          <p>
            La aceptación de estos Términos y Condiciones es obligatoria para el uso de la Plataforma Clinifica.
          </p>
          <p>
            El acceso, registro y uso de la plataforma Clinifica por parte del Usuario está condicionado a la lectura, aceptación y cumplimiento íntegro de los presentes Términos y Condiciones. Al acceder, navegar, registrarse o utilizar la plataforma de cualquier forma, el Usuario declara conocer, entender y aceptar expresamente que estos Términos son legalmente vinculantes y obligatorios. En caso de no aceptar total o parcialmente estos Términos y Condiciones, el Usuario deberá abstenerse de utilizar la Plataforma y los servicios ofrecidos por Clinifica.
          </p>

          <h3>2.1 Requisitos para el uso de la plataforma</h3>
          <p>
            Solo podrán registrarse y utilizar los servicios profesionales de Clinifica aquellas personas naturales que ejerzan una profesión del área de la salud y que se encuentren debidamente acreditadas ante la Superintendencia de Salud de Chile, conforme a la normativa vigente.
          </p>

          <h3>2.2 Vigencia del servicio</h3>
          <p>
            Los Usuarios que contraten una <em>suscripción mensual</em> accederán a los servicios de Clinifica bajo una modalidad de renovación automática mes a mes, salvo que manifiesten su intención de cancelar conforme a los procedimientos establecidos.
          </p>
          <p>
            Los Usuarios que opten por una <em>suscripción anual</em> contarán con un período de vigencia de doce (12) meses corridos desde la fecha de activación del servicio. Esta modalidad no contempla reembolsos por los meses no utilizados, ya que el pago corresponde a un periodo fijo y completo.
          </p>

          <h2>3. DEFINICIONES CLAVE</h2>
          <p><strong>Plataforma:</strong> Se refiere al conjunto de servicios digitales ofrecidos por Clinifica Chile SpA a través del sitio web y sus sistemas asociados, orientados a la gestión clínica, administrativa, financiera y digital de profesionales de la salud independientes.</p>
          <p><strong>Clinifica o la Empresa:</strong> Hace referencia a Clinifica Chile SpA, RUT 77.729.376-1, proveedor del software como servicio (SaaS), domiciliado en Eulogio Sánchez 065, Providencia, Santiago, Chile.</p>
          <p><strong>Usuario o Usuario Profesional:</strong> Persona natural que ejerce una profesión en el área de la salud, debidamente acreditada ante la Superintendencia de Salud de Chile, y que se registra en la Plataforma para utilizar sus servicios.</p>
          <p><strong>Paciente:</strong> Persona natural que recibe atención por parte del Usuario Profesional y cuyos datos pueden ser gestionados mediante la Plataforma.</p>
          <p><strong>SaaS (Software as a Service):</strong> Modelo de distribución de software donde Clinifica proporciona acceso remoto a su sistema a través de internet, sin necesidad de instalación local por parte del Usuario.</p>
          <p><strong>Portal de Gestión:</strong> Área privada de acceso restringido dentro de la Plataforma, donde el Usuario puede gestionar su agenda, pacientes, servicios, finanzas y configuraciones personales.</p>
          <p><strong>Perfil Web Profesional:</strong> Página pública asociada a cada Usuario, que actúa como tarjeta de presentación digital, permitiendo a los pacientes conocer al profesional, agendar sesiones y realizar pagos.</p>
          <p><strong>Buscador de Profesionales:</strong> Sección pública de la Plataforma en la que se listan los Usuarios activos, permitiendo a los pacientes buscar atención por especialidad, ubicación o modalidad.</p>
          <p><strong>Cuenta:</strong> Registro digital individual creado por el Usuario en la Plataforma, que le permite acceder a sus funcionalidades personalizadas mediante autenticación (correo electrónico y contraseña).</p>
          <p><strong>Plan de Suscripción:</strong> Conjunto de funcionalidades y condiciones de acceso ofrecidas por Clinifica, asociado a un modelo de pago específico (gratuito, mensual o anual).</p>
          <p><strong>Mandato Especial:</strong> Autorización expresa e irrevocable otorgada por el Usuario a Clinifica para actuar en su representación en materias como procesamiento de pagos, emisión de boletas electrónicas o tramitación de bonos FONASA.</p>
          <p><strong>Servicios:</strong> Acciones y prestaciones profesionales de salud que el Usuario ofrece a sus pacientes a través de la Plataforma.</p>
          <p><strong>Ley N° 19.628:</strong> Ley chilena sobre protección de la vida privada y tratamiento de datos personales.</p>
          <p><strong>Ley N° 20.584:</strong> Ley chilena que regula los derechos y deberes de las personas en relación con acciones vinculadas a su atención de salud.</p>
          <p><strong>Superintendencia de Salud:</strong> Entidad pública chilena encargada de supervisar y fiscalizar a los prestadores de salud y profesionales acreditados en el país.</p>

          <h2>4. OBJETO DEL SERVICIO</h2>
          <p>
            Clinifica es una plataforma digital de software como servicio (SaaS), desarrollada por Clinifica Chile SpA, que proporciona herramientas tecnológicas diseñadas para facilitar la gestión clínica, administrativa y digital de profesionales independientes del área de la salud en Chile.
          </p>
          <p>
            La Plataforma está orientada exclusivamente a profesionales de la salud debidamente acreditados ante la Superintendencia de Salud y tiene como finalidad optimizar su desempeño profesional, brindando un sistema integral para la organización de sus atenciones, visibilidad digital y control financiero. La Plataforma se compone de tres productos principales:
          </p>

          <h3>4.1 Portal de Gestión y Administración Clínica</h3>
          <p>
            Clinifica pone a disposición del Usuario un portal privado de acceso exclusivo, autenticado mediante credenciales personales (correo electrónico y contraseña), cuyo propósito es facilitar la administración de su actividad profesional en salud. Este espacio está diseñado para captar, gestionar y rentabilizar la atención clínica brindada por el Usuario profesional, mediante un conjunto de herramientas tecnológicas desarrolladas específicamente para profesionales independientes de la salud.
          </p>
          <p>El portal de gestión y administración clínica permite, en términos generales:</p>
          <ul>
            <li>Visualizar, organizar y administrar su agenda profesional.</li>
            <li>Gestionar información clínica y de contacto relacionada con sus pacientes.</li>
            <li>Configurar y mantener su perfil profesional visible públicamente.</li>
            <li>Definir y personalizar su oferta de servicios, modalidades de atención y horarios.</li>
            <li>Gestionar procesos administrativos y financieros asociados a su práctica clínica.</li>
            <li>Conectar, cuando corresponda, con servicios externos pertinentes para su ejercicio profesional.</li>
          </ul>
          <p>
            Las funcionalidades específicas ofrecidas dentro del portal podrán variar, actualizarse o modificarse a lo largo del tiempo, de acuerdo con la evolución tecnológica de Clinifica, las necesidades del sistema y la mejora continua del servicio. La Plataforma no garantiza la permanencia indefinida de ninguna herramienta particular, ni se obliga a mantener una determinada estructura o conjunto de funciones, quedando estas sujetas a cambios sin necesidad de notificación previa al Usuario.
          </p>

          <h3>4.2 Perfil Web Profesional</h3>
          <p>
            Es un sitio web personalizado vinculado directamente a la cuenta del Usuario, que actúa como una tarjeta de presentación digital. En él, los pacientes pueden conocer al profesional, su enfoque de atención, sus servicios y agendar sesiones directamente desde dicho sitio. Este perfil también permite realizar pagos por los servicios agendados mediante un flujo automatizado.
          </p>

          <h3>4.3 Buscador de Profesionales de la Salud</h3>
          <p>
            Es una plataforma web pública donde se listan los profesionales que actualmente utilizan los servicios de Clinifica. Los pacientes pueden buscar atención filtrando por especialidad, ubicación geográfica o modalidad de atención, con el objetivo de facilitar el contacto y la contratación de servicios.
          </p>
          <p>
            Es importante recalcar que la plataforma no interfiere en la relación profesional entre el Usuario y sus pacientes, ni presta servicios de salud por sí misma. Clinifica se limita a actuar como proveedor tecnológico, facilitando la infraestructura para que cada Profesional gestione su ejercicio de manera autónoma y conforme a las normativas sanitarias y éticas vigentes.
          </p>

          <h2>5. REGISTRO Y ACCESO A LA CUENTA</h2>

          <h3>5.1 Información proporcionada y registro del profesional</h3>
          <p>
            El Usuario declara y garantiza que la información proporcionada al momento del registro es veraz, completa y actualizada. Asimismo, se compromete a mantener sus credenciales de acceso (correo electrónico y contraseña) bajo estricta confidencialidad y a no compartirlas con terceros. Cada cuenta registrada es personal e intransferible.
          </p>
          <p>
            Para utilizar los servicios ofrecidos por Clinifica, el Usuario deberá registrarse creando una cuenta personal a través del flujo de inscripción disponible en nuestra página principal o landing page para profesionales de la salud. Durante este proceso, el Usuario deberá seleccionar un plan de suscripción determinado, cuyas funcionalidades y precios estarán siempre visibles y actualizados en dicho sitio.
          </p>

          <h3>5.2 Acceso a la cuenta</h3>
          <p>
            El acceso y uso de la Plataforma está restringido exclusivamente a personas mayores de 18 años que sean profesionales del área de la salud debidamente acreditados ante la Superintendencia de Salud de Chile. Clinifica validará dicha acreditación como parte del proceso de registro. Está expresamente prohibido el registro de personas que no cumplan con estas condiciones.
          </p>
          <p>
            Una vez registrado, el profesional podrá acceder a su cuenta mediante cualquier dispositivo que cuente con buscador web y mantenga conexión a internet, la dirección web de ingreso es <a href="https://pro.clinifica.com/" target="_blank" rel="noopener noreferrer">https://pro.clinifica.com/</a>
          </p>

          <h2>6. CONDICIONES DE USO</h2>

          <h3>6.1 Licencia de uso limitada y no exclusiva</h3>
          <p>
            Clinifica otorga al Usuario una licencia limitada, no exclusiva, intransferible y revocable para utilizar la Plataforma y sus funcionalidades, exclusivamente para el ejercicio de su actividad profesional como prestador de servicios de salud en Chile, y conforme a los presentes Términos y Condiciones.
          </p>
          <p>
            Esta licencia no implica, en ningún caso, la cesión o transferencia de derechos de propiedad intelectual sobre el software, su código, diseño, interfaz, base de datos, contenido u otros elementos que forman parte de la Plataforma. El Usuario se compromete a no reproducir, copiar, modificar, adaptar, traducir, desensamblar, realizar ingeniería inversa ni crear obras derivadas basadas en Clinifica o en cualquiera de sus componentes, sin autorización expresa y por escrito de la Empresa.
          </p>

          <h3>6.2 Buenas prácticas y usos prohibidos</h3>
          <p>
            El Usuario declara expresamente que el uso que le dará a la Plataforma será exclusivamente con fines profesionales de la salud, respetando en todo momento la normativa sanitaria, ética y legal vigente en la República de Chile. En particular, se considera expresamente prohibido:
          </p>
          <ul>
            <li>Utilizar la Plataforma para actividades ilícitas, engañosas o que contravengan la normativa sanitaria o profesional vigente.</li>
            <li>Suplantar la identidad de otros profesionales o ingresar información falsa o sin autorización.</li>
            <li>Ingresar, almacenar o difundir contenidos que vulneren derechos de terceros o que sean ofensivos, discriminatorios, difamatorios o contrarios a las buenas costumbres.</li>
            <li>Utilizar la Plataforma para ofrecer servicios que el Usuario no se encuentre legalmente habilitado para realizar.</li>
            <li>Interferir, dañar o intentar vulnerar la seguridad, disponibilidad o funcionamiento técnico de la Plataforma.</li>
            <li>Acceder o intentar acceder a cuentas ajenas sin autorización.</li>
          </ul>
          <p>
            El incumplimiento de estas condiciones podrá dar lugar a la suspensión temporal o cancelación definitiva de la cuenta, sin derecho a indemnización ni reembolso, y eventualmente a la persecución de responsabilidades legales.
          </p>

          <h3>6.3 Uso conforme a la normativa sanitaria chilena</h3>
          <p>
            El Usuario se obliga a utilizar la Plataforma en estricto cumplimiento de las leyes, reglamentos y normas aplicables al ejercicio profesional en el área de la salud en Chile, incluyendo, pero no limitado a:
          </p>
          <ul>
            <li>La Ley N° 20.584 sobre derechos y deberes de las personas en relación con acciones vinculadas a su atención de salud.</li>
            <li>La Ley N° 19.628 sobre protección de la vida privada y el tratamiento de datos personales.</li>
            <li>Las normas técnicas y éticas establecidas por el Ministerio de Salud, la Superintendencia de Salud y los respectivos colegios profesionales, en caso de existir.</li>
          </ul>
          <p>
            El uso de Clinifica no exime al Usuario de su responsabilidad legal y ética ante sus pacientes, ni sustituye el juicio clínico profesional, siendo el Usuario el único responsable del uso que haga de la información y herramientas disponibles en la Plataforma.
          </p>

          <h2>7. PROTECCIÓN DE DATOS PERSONALES Y CONFIDENCIALIDAD</h2>

          <h3>7.1 Legislación Aplicable</h3>
          <p>
            El tratamiento de datos personales por parte de Clinifica y de sus usuarios se regirá por la legislación chilena vigente, en particular:
          </p>
          <ul>
            <li><strong>Ley N° 19.628</strong>, sobre Protección de la Vida Privada;</li>
            <li><strong>Ley N° 20.584</strong>, que regula los derechos y deberes que tienen las personas en relación con acciones vinculadas a su atención en salud;</li>
            <li><strong>Ley N° 21.459</strong>, sobre delitos informáticos, en lo que corresponda;</li>
            <li>Otras normativas sectoriales y técnicas aplicables al tratamiento de datos personales en contextos sanitarios.</li>
          </ul>

          <h3>7.2 Tratamiento de Datos por Parte de Clinifica</h3>
          <p>
            Clinifica actúa como <strong>encargado del tratamiento</strong> de los datos personales ingresados y gestionados a través de la plataforma, en la medida que estos sean tratados por cuenta de los profesionales de la salud que utilizan el servicio. En ningún caso Clinifica determinará los fines ni los medios del tratamiento de los datos clínicos o personales de los pacientes, sino que provee una infraestructura tecnológica segura para su almacenamiento y gestión.
          </p>
          <p>
            Clinifica implementa medidas técnicas y organizativas suficientes y razonables para proteger la confidencialidad, integridad y disponibilidad de los datos personales, incluyendo el cifrado, control de acceso y políticas de respaldo alineadas con la normativa y ley vigente.
          </p>

          <h3>7.3 Tratamiento de Datos por Parte del Usuario Profesional</h3>
          <p>
            El usuario profesional de salud (en adelante, el "Usuario") es el <strong>responsable del tratamiento</strong> de los datos personales y/o sensibles que incorpore, gestione o procese en la plataforma Clinifica, en conformidad con la Ley N° 20.584 y demás normativa sanitaria.
          </p>
          <p>
            El Usuario declara que cuenta con las bases legales necesarias (consentimiento informado, obligación legal, interés vital, etc.) para el tratamiento de los datos personales de sus pacientes, y se compromete a respetar la confidencialidad y derechos de los titulares de dichos datos.
          </p>
          <p>Asimismo, el Usuario se obliga especialmente a:</p>
          <ul>
            <li>No utilizar la plataforma para finalidades incompatibles con la normativa sanitaria;</li>
            <li>No divulgar datos personales o sensibles sin autorización del titular o sin contar con fundamento legal válido;</li>
            <li>Adoptar medidas de seguridad adicionales en caso de tratar información especialmente protegida (antecedentes clínicos, diagnósticos, etc.);</li>
            <li>Informar a sus pacientes sobre el uso de herramientas digitales como Clinifica para la gestión de sus datos de salud, en el marco del consentimiento informado.</li>
          </ul>

          <h3>7.4 Confidencialidad de la Información</h3>
          <p>
            Durante la vigencia de la relación contractual, y por un período de al menos <strong>dos (2) años</strong> desde su término, ambas partes se comprometen a mantener en estricta confidencialidad toda información no pública a la que tengan acceso con ocasión del uso de la plataforma. Esto incluye, pero no se limita a, información clínica, técnica, comercial o estratégica.
          </p>
          <p>No se considerará confidencial aquella información que:</p>
          <ul>
            <li>Sea de conocimiento público sin violación de este acuerdo;</li>
            <li>Haya sido conocida previamente por la parte receptora en forma lícita;</li>
            <li>Deba ser divulgada por orden de autoridad competente, en cuyo caso se notificará a la otra parte con antelación, cuando sea legalmente posible;</li>
            <li>Haya sido anonimizada de forma tal que no permita identificar a personas naturales o jurídicas.</li>
          </ul>

          <h3>7.5 Responsabilidad Compartida</h3>
          <p>
            Clinifica y el Usuario reconocen la existencia de una <strong>responsabilidad compartida</strong> respecto del tratamiento de datos personales. Clinifica provee la infraestructura y mecanismos técnicos necesarios para el tratamiento seguro de los datos, mientras que el Usuario profesional tiene la responsabilidad de gestionar, controlar y asegurar el cumplimiento normativo respecto de los datos personales de sus pacientes.
          </p>
          <p>
            El incumplimiento grave de estas obligaciones por parte del Usuario podrá dar lugar a la suspensión o eliminación de su cuenta, sin perjuicio de las acciones legales que correspondan.
          </p>

          <h2>8. PLANES, PAGOS Y FACTURACIÓN</h2>

          <h3>8.1 Tipos de Planes</h3>
          <p>
            Clinifica ofrece distintos planes de acceso a la plataforma, orientados a profesionales de la salud en diferentes etapas de su ejercicio independiente. Actualmente, se contemplan tres modalidades principales:
          </p>
          <ul>
            <li><strong>Plan Básico (Gratuito)</strong></li>
            <li><strong>Plan Light</strong></li>
            <li><strong>Plan Pro</strong></li>
          </ul>
          <p>
            Clinifica se reserva el derecho de modificar, eliminar o crear nuevos planes de suscripción, así como de ajustar sus características y precios, previa notificación a los usuarios.
          </p>

          <h3>8.2 Métodos de Pago y Condiciones</h3>
          <p>
            Los planes pagados podrán ser contratados mediante <strong>suscripción mensual automática</strong>, con pagos recurrentes realizados a través de:
          </p>
          <ul>
            <li><strong>Tarjetas de crédito</strong> (VISA, Mastercard, etc.);</li>
            <li><strong>Tarjetas de débito</strong> habilitadas para pagos con mandato de cargo automático mensual (PAT, PAC o equivalentes).</li>
          </ul>
          <p>
            El cobro se efectuará de forma anticipada al inicio de cada ciclo mensual. En caso de que el pago no pueda procesarse, Clinifica podrá notificar al usuario y otorgar un plazo para regularizar la situación. De no regularizarse, se procederá a la suspensión temporal del acceso al plan pagado, manteniendo acceso al plan básico si corresponde.
          </p>
          <p>
            Los precios de los planes se expresarán en pesos chilenos (CLP) y no incluyen los impuestos correspondientes, salvo que se indique lo contrario. Por lo cual el usuario deberá contar con adicionar el 19% por el impuesto al valor agregado.
          </p>

          <h3>8.3 Renovaciones y Cancelaciones</h3>
          <p>
            Los planes de suscripción en Clinifica se renuevan automáticamente al finalizar cada período de facturación, ya sea mensual o anual, dependiendo del plan contratado por el profesional. Al suscribirse, el Usuario autoriza expresamente a que se realice el cobro automático a través del medio de pago registrado, ya sea tarjeta de crédito o débito con mandato de pago, lo anterior ocurrirá salvo que el usuario cancele su suscripción antes del término del ciclo vigente. La cancelación podrá realizarse desde el panel de configuración de cuenta, sin necesidad de justificar causa.
          </p>
          <ul>
            <li><strong>Cancelación voluntaria:</strong> El Usuario podrá cancelar su suscripción en cualquier momento desde su cuenta en la plataforma. La cancelación impedirá la renovación automática del siguiente período, manteniéndose activo el acceso al plan hasta el término del ciclo de facturación vigente. No se realizarán reembolsos por períodos ya pagados, incluyendo los meses no utilizados, especialmente en suscripciones anuales cuyo cobro corresponde a un período completo.</li>
            <li><strong>Suspensión por impago:</strong> En caso de no poder procesar el cobro correspondiente, se notificará al usuario y se dará un plazo de gracia razonable para regularizar el pago. Si transcurrido dicho plazo no se resuelve la situación, Clinifica podrá degradar el acceso del usuario al plan gratuito o suspender temporalmente el servicio.</li>
            <li><strong>Reactivación:</strong> Los usuarios podrán reactivar su suscripción en cualquier momento desde su cuenta, aplicando las condiciones vigentes al momento de la reactivación.</li>
            <li><strong>Eliminación de la cuenta:</strong> La cancelación de un plan no implica necesariamente la eliminación inmediata de la cuenta o de los datos del usuario, los cuales se conservarán conforme a lo señalado en la cláusula de Vigencia del Servicio y conforme a la normativa sobre protección de datos.</li>
          </ul>

          <h3>8.4 Modificaciones y Notificaciones</h3>
          <p>
            Cualquier modificación en los precios, condiciones de suscripción, métodos de pago u otras disposiciones relacionadas con planes pagados será debidamente notificada a los usuarios con al menos <strong>15 días de anticipación</strong> antes de su entrada en vigencia.
          </p>

          <h2>9. MODIFICACIONES AL SERVICIO Y A LOS TÉRMINOS</h2>

          <h3>9.1 Cambios en funcionalidades, precios o términos</h3>
          <p>
            Clinifica se reserva el derecho a modificar, actualizar o suspender total o parcialmente las funcionalidades del software, así como a ajustar los precios de los planes de suscripción o realizar cambios en estos Términos y Condiciones. Estas modificaciones podrán responder a mejoras del servicio, cambios normativos, ajustes comerciales o nuevas necesidades detectadas en la comunidad usuaria.
          </p>
          <p>
            En el caso de los planes gratuitos, Clinifica podrá modificar las funcionalidades ofrecidas sin necesidad de previo aviso. Para los planes de pago, cualquier cambio sustancial en funcionalidades o precios será notificado con una antelación de 14 días antes de su entrada en vigor.
          </p>

          <h3>9.2 Mecanismos de notificación y aceptación</h3>
          <p>
            Toda modificación relevante será comunicada al Usuario a través de los canales oficiales de Clinifica, incluyendo notificaciones dentro de la plataforma, correo electrónico y mediante la publicación de los términos actualizados en el sitio web oficial.
          </p>
          <p>
            Se entenderá que el Usuario acepta las modificaciones si continúa utilizando el servicio luego de la fecha de entrada en vigor de los nuevos Términos. Si el Usuario no está de acuerdo con los cambios, podrá cancelar su suscripción antes de su aplicación, conforme a lo establecido en el punto 8.3.
          </p>

          <h2>10. SUSPENSIÓN Y TERMINACIÓN DE CUENTAS</h2>

          <h3>10.1 Causales de suspensión o terminación por parte de Clinifica</h3>
          <p>
            Clinifica podrá suspender temporalmente, limitar funcionalidades o terminar de forma definitiva una cuenta de Usuario en cualquiera de los siguientes casos:
          </p>
          <ul>
            <li>Incumplimiento sustancial de estos Términos y Condiciones, incluyendo pero no limitado a los establecidos en las secciones sobre Condiciones de uso, Pagos y Confidencialidad.</li>
            <li>Uso indebido o ilegal del software, como el intento de manipular información, vulnerar la seguridad del sistema o utilizar la plataforma con fines distintos a los declarados (por ejemplo, promoción engañosa o spam).</li>
            <li>Suplantación de identidad, uso del perfil por personas no autorizadas o entrega de información falsa o engañosa, ya sea sobre el profesional, su formación, experiencia, identidad o licencias.</li>
            <li>Manipulación intencionada de valoraciones, testimonios o feedback dentro de la plataforma.</li>
            <li>Comportamiento inapropiado, ofensivo o que atente contra la integridad de otros usuarios o del equipo de Clinifica, incluyendo lenguaje amenazante, discriminatorio, difamatorio o abusivo.</li>
            <li>Indicios fundados de que el Profesional ha infringido normas éticas, reglamentos sanitarios, obligaciones legales vigentes en Chile o que su conducta pudiera generar un riesgo o perjuicio para pacientes, terceros o para la reputación de Clinifica.</li>
          </ul>

          <h3>10.2 Procedimiento y derecho a réplica</h3>
          <p>
            Salvo en los casos de gravedad manifiesta, Clinifica notificará por escrito al Usuario el motivo de la suspensión o intención de terminación, otorgando un plazo de 10 días corridos para que el Usuario pueda presentar sus descargos o subsanar el incumplimiento, si fuese posible.
          </p>
          <p>
            En caso de no recibir respuesta o no corregirse la conducta dentro del plazo, Clinifica podrá proceder a la cancelación definitiva del acceso.
          </p>

          <h3>10.3 Terminación voluntaria por parte del Usuario</h3>
          <p>
            El Usuario podrá en cualquier momento solicitar la baja del servicio, conforme a lo indicado en el punto 8.3, sin perjuicio de los efectos que ello tenga en relación con la suscripción activa.
          </p>

          <h3>10.4 Efectos de la terminación</h3>
          <p>
            Una vez finalizado el vínculo contractual, el acceso al software y a las funcionalidades del plan suscrito se desactivarán, quedando inhabilitado el acceso a la plataforma. Clinifica podrá conservar cierta información por el tiempo legalmente necesario y conforme a lo señalado en la Política de Privacidad.
          </p>

          <h2>11. RESPONSABILIDAD Y LIMITACIONES LEGALES</h2>

          <h3>11.1 Responsabilidad del Usuario Profesional</h3>
          <p>
            El Usuario Profesional es el único responsable del uso que haga de la plataforma Clinifica, así como del contenido que ingrese, almacene o gestione en ella. Esto incluye, pero no se limita a:
          </p>
          <ul>
            <li>La veracidad, legalidad y exactitud de los datos personales o clínicos que registre en la plataforma.</li>
            <li>La obtención de consentimientos informados y válidos por parte de sus pacientes, en conformidad con la Ley N° 20.584, la Ley N° 19.628 y demás normativas aplicables.</li>
            <li>La legalidad y calidad de los servicios profesionales de salud que preste, eximiendo expresamente a Clinifica de cualquier responsabilidad derivada de dichos servicios.</li>
            <li>El cumplimiento de sus deberes éticos, contractuales, administrativos y legales como profesional de la salud ante la Superintendencia de Salud y demás organismos competentes.</li>
          </ul>

          <h3>11.2 Limitación de responsabilidad de Clinifica</h3>
          <p>
            Clinifica actúa exclusivamente como proveedor tecnológico de una plataforma digital de apoyo a la gestión de profesionales de la salud, y no participa en la relación entre estos y sus pacientes. En consecuencia:
          </p>
          <ul>
            <li>Clinifica <strong>no será responsable</strong> por fallos en la calidad, oportunidad, precisión, legalidad, cumplimiento o ejecución de los servicios que el Usuario Profesional preste a sus pacientes.</li>
            <li>Clinifica <strong>no garantiza</strong> la continuidad del servicio en caso de eventos fuera de su control razonable (ej. cortes de internet, desastres naturales, actos de fuerza mayor, hackeos externos, etc.).</li>
            <li>Clinifica <strong>no asume responsabilidad por lucro cesante, pérdida de datos, interrupción de actividades médicas, daño moral, ni daños indirectos o imprevistos</strong> derivados del uso o imposibilidad de uso de la plataforma.</li>
            <li>Clinifica <strong>no responde por el acceso no autorizado a cuentas de Usuario</strong> por parte de terceros, salvo que dicho acceso sea atribuible a negligencia grave o dolo de Clinifica.</li>
          </ul>

          <h3>11.3 Exclusión de responsabilidad en materia clínica y sanitaria</h3>
          <p>
            Clinifica no supervisa, valida ni interfiere en los diagnósticos, tratamientos, orientaciones clínicas ni en la comunicación entre profesionales y pacientes. Por lo tanto, <strong>no es responsable de actos de negligencia médica, mala praxis ni deficiencias en la atención brindada a los pacientes</strong>. El Usuario Profesional declara entender y aceptar que él o ella es el único(a) responsable por tales actuaciones.
          </p>

          <h3>11.4 Indemnidad</h3>
          <p>
            El Usuario Profesional se compromete a indemnizar, defender y mantener indemne a Clinifica, sus socios, directores, colaboradores, representantes y afiliados, de y contra cualquier demanda, reclamo, acción judicial o extrajudicial, sanción, multa, daño, pérdida o gasto (incluidos honorarios legales) que se derive de:
          </p>
          <ul>
            <li>El uso indebido o ilegal de la plataforma.</li>
            <li>El incumplimiento de estos Términos y Condiciones.</li>
            <li>La prestación de servicios profesionales por parte del Usuario.</li>
            <li>Cualquier violación de la normativa vigente en materia de salud, protección de datos o ejercicio profesional.</li>
          </ul>

          <h3>11.5 Responsabilidad ante terceros y autoridad competente</h3>
          <p>
            En caso de que Clinifica reciba requerimientos, reclamos o investigaciones por parte de pacientes, autoridades administrativas o judiciales a raíz de la actividad del Usuario, este se obliga a colaborar activamente en la entrega de antecedentes, y asumir los costos o perjuicios que se deriven de su actuar profesional, sin imputar responsabilidad a Clinifica.
          </p>

          <h2>12. MANDATO ESPECIAL PARA GESTIÓN DE COBROS, EMISIÓN DE BOLETAS Y TRAMITACIÓN DE BENEFICIOS DE SALUD</h2>

          <h3>12.1 Otorgamiento del mandato</h3>
          <p>
            El Usuario Profesional otorga a Clinifica Chile SpA, en adelante "Clinifica", un <strong>mandato especial</strong>, irrevocable mientras mantenga un perfil activo en la plataforma, para que actúe en su nombre y representación con el fin de:
          </p>
          <ul>
            <li>Cobrar, percibir, recibir y recaudar de sus pacientes o clientes cualquier suma adeudada por concepto de prestaciones o servicios profesionales prestados, ya sea mediante medios de pago electrónicos u otros habilitados por la plataforma.</li>
            <li>Emitir boletas de honorarios electrónicas a través del Servicio de Impuestos Internos (SII) por los servicios efectivamente prestados por el Profesional al paciente correspondiente, en los términos y condiciones que el Profesional haya configurado previamente en la plataforma.</li>
            <li>Tramitar y emitir, en su nombre, bonos de atención de salud (bonos electrónicos) y demás prestaciones bonificadas ante el Fondo Nacional de Salud (FONASA), en los casos en que la funcionalidad esté disponible.</li>
          </ul>

          <h3>12.2 Extinción de la obligación del paciente</h3>
          <p>
            Una vez percibido el pago realizado por parte del paciente, Clinifica se entenderá válidamente facultada para extinguir la correspondiente obligación de pago que dicho paciente mantiene con el Usuario Profesional, actuando como su mandataria para tales efectos.
          </p>

          <h3>12.3 Transferencia de fondos</h3>
          <p>
            Clinifica podrá transferir los montos percibidos a la cuenta bancaria informada por el Usuario Profesional en la plataforma, descontando previamente cualquier comisión, tarifa o cargo que resulte aplicable conforme a estos Términos y Condiciones.
          </p>
          <p>
            Los fondos recaudados serán entregados al Profesional en un plazo mínimo de 7 días corridos contados desde la fecha de recaudación efectiva. Sin perjuicio de lo anterior, en casos excepcionales como inconvenientes de carácter sistémico, bancario o situaciones de fuerza mayor debidamente justificadas, dicho plazo podrá extenderse hasta un máximo de 28 días corridos.
          </p>

          <h3>12.4 Límites del mandato</h3>
          <p>
            Este mandato se otorga exclusivamente para facilitar el funcionamiento operativo y administrativo de los servicios ofrecidos a través de la plataforma Clinifica. No otorga a Clinifica facultades distintas o más amplias que las expresamente señaladas en la presente cláusula.
          </p>

          <h3>12.5 Alcance respecto a FONASA</h3>
          <p>
            En el caso de prestaciones bonificadas por FONASA, el Profesional autoriza expresamente a Clinifica para percibir directamente, en su nombre, los montos correspondientes al <strong>copago</strong> abonado por el paciente al momento de utilizar un bono electrónico de atención de salud. Clinifica actuará como intermediaria para la recepción y posterior transferencia de dichos montos a la cuenta bancaria informada por el Profesional.
          </p>

          <h2>13. COMISIONES POR PROCESAMIENTO DE PAGOS</h2>
          <p>
            Con el objetivo de garantizar el funcionamiento eficiente, seguro y automatizado del sistema de pagos en la Plataforma, así como de cubrir los costos asociados al procesamiento de transacciones y transferencias, <strong>Clinifica</strong> aplica los siguientes cobros adicionales al uso de sus funcionalidades de pago:
          </p>

          <h3>13.1 Comisión por uso de pasarela de pago</h3>
          <p>
            Por cada transacción realizada a través de la Plataforma mediante tarjetas de crédito, tarjetas de débito o transferencias bancarias, se aplicará una comisión del <strong>3,9% (tres coma nueve por ciento) + IVA</strong> correspondiente, sobre el monto total pagado por el Paciente.
          </p>
          <p>
            Dicha comisión será automáticamente descontada del monto recaudado y se aplicará con independencia del plan de suscripción contratado por el Usuario Profesional. Este porcentaje corresponde al uso de los servicios tecnológicos de pasarela de pago (como Transbank u otros equivalentes), así como al soporte digital complementario que facilita el flujo completo de agendamiento, recordatorios, pagos y boletas.
          </p>

          <h3>13.2 Cargo fijo por transacción</h3>
          <p>
            Además de la comisión por uso de las pasarelas de pago señalada en la cláusula anterior, Clinifica aplicará un cargo fijo por cada transacción exitosa realizada a través de la Plataforma, cuyo monto dependerá del plan de suscripción contratado por el Usuario Profesional:
          </p>
          <ul>
            <li><strong>Plan Básico (gratuito):</strong> cargo fijo por transacción de $490 pesos chilenos + IVA.</li>
            <li><strong>Plan Light:</strong> cargo fijo por transacción de $190 pesos chilenos + IVA.</li>
            <li><strong>Plan Pro:</strong> sin cargo fijo por transacción.</li>
          </ul>
          <p>
            Este cargo fijo será siempre de responsabilidad del Usuario Profesional, independientemente de la modalidad de atención, del monto cobrado al paciente o del método de pago utilizado. El monto correspondiente será deducido automáticamente del total recaudado antes de su transferencia a la cuenta bancaria del Usuario.
          </p>
          <p>
            Clinifica se reserva el derecho de modificar estos valores en el futuro, lo que será debidamente informado en la plataforma y en los medios oficiales de comunicación. El uso continuado del servicio por parte del Usuario constituirá aceptación tácita de las nuevas condiciones.
          </p>

          <h3>13.3 Naturaleza adicional de estas comisiones</h3>
          <p>
            Tanto la comisión por pasarela de pago como el cargo fijo por transacción no forman parte del precio del plan de suscripción mensual o anual contratado por el Usuario Profesional. Se trata de cargos adicionales que se aplican solo cuando el Profesional utiliza el sistema de cobro automatizado de la Plataforma, y su vigencia se mantendrá mientras Clinifica preste estos servicios.
          </p>
          <p>
            Clinifica se reserva el derecho a modificar, eliminar o aplicar descuentos sobre estos porcentajes y cargos en cualquier momento, ya sea con fines comerciales, ajustes en los planes disponibles u otras definiciones internas. Cualquier cambio será notificado oportunamente conforme al mecanismo descrito en la cláusula de "Modificaciones al Servicio y a los Términos".
          </p>

          <h2>14. NORMATIVA APLICABLE Y JURISDICCIÓN</h2>

          <h3>14.1 Legislación aplicable</h3>
          <p>
            Los presentes Términos y Condiciones, así como cualquier relación derivada del uso de la plataforma Clinifica, se regirán por las leyes de la República de Chile, en particular por las disposiciones aplicables al comercio electrónico, protección de datos personales y derechos del consumidor, según corresponda.
          </p>

          <h3>14.2 Jurisdicción competente</h3>
          <p>
            Para todos los efectos legales, las partes fijan su domicilio en la ciudad de Santiago, Región Metropolitana, y se someten a la jurisdicción de sus tribunales ordinarios de justicia, renunciando a cualquier otro fuero que pudiera corresponderles por razón de su domicilio presente o futuro.
          </p>

          <h2>15. Contacto y soporte</h2>
          <p>
            Para consultas sobre el uso de la plataforma, funcionamiento técnico o asistencia con funcionalidades, los usuarios pueden contactar al equipo de soporte de Clinifica a través del siguiente canal:
          </p>
          <p>📩 Correo electrónicos: <a href="mailto:felipe@clinifica.com">felipe@clinifica.com</a> y <a href="mailto:pablo@clinifica.com">pablo@clinifica.com</a></p>
          <p>📲 Whatsapp: +56 9 2080 9101</p>
        </Box>
      </Box>

      {renderClinicaPillButton()}
    </>
  );
}

export default TerminosCondiciones;